import { render, staticRenderFns } from "./ListsForSignedInUsersModal.vue?vue&type=template&id=2b48b328"
import script from "./ListsForSignedInUsersModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListsForSignedInUsersModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListsForSignedInUsersModal.vue?vue&type=style&index=0&id=2b48b328&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports